import { DefaultCellHeader } from "app/components/React/Table/headerCells";
import { getAffinityColumns } from "app/pages/app-intelligence/app-analysis/pages/interests/configs/appAffinityColumns";

import { TableWidget } from "./TableWidget";

type TooltipType = {
    appStore: string;
    author: string;
    category: string;
    icon: string;
    price: string;
    title: string;
};

type AudienceItem = {
    Affinity: number;
    AppID: string;
    CategoryRank: number;
    CountryRank: number;
    Icon: string;
    MainCategoryID: string;
    Publisher: string;
    Title: string;
    Tooltip: TooltipType;
};

type AudienceTableResponse = Record<
    string,
    {
        Table: {
            FilteredCount: number;
            PageNumber: number;
            PageSize: number;
            TotalCount: number;
            Records: AudienceItem[];
        };
    }
>;

const COLUMN_NAMES = ["Title", "Publisher", "MainCategoryID", "CategoryRank", "Affinity"];

export class AppDistributionTableWidget extends TableWidget {
    constructor() {
        super();
    }

    static getWidgetMetadataType() {
        return "AppDistributionTable";
    }

    static getWidgetResourceType() {
        return "Table";
    }

    static getWidgetDashboardType() {
        return "Table";
    }

    public isPptSupported = () => {
        return false;
    };

    public getData() {
        const appId = this._params.keys;
        this._params.appId = appId;

        return super.getData();
    }

    private transformData(rawResponse: AudienceTableResponse) {
        const transformedData = { Data: null };
        const key = Object.keys(rawResponse)[0];
        transformedData.Data = rawResponse[key]?.Table?.Records;
        return transformedData;
    }

    public async onNewDataReceived(response: AudienceTableResponse): Promise<void> {
        const transformedResponse = this.transformData(response);
        await super.onNewDataReceived(transformedResponse);
    }

    protected getMetricColumnsConfig() {
        return getAffinityColumns().reduce((acc, col) => {
            if (COLUMN_NAMES.includes(col.field)) {
                acc.push({
                    ...col,
                    headerComponent: DefaultCellHeader,
                    title: col.displayName,
                });
            }
            return acc;
        }, []);
    }
}

AppDistributionTableWidget.register();
